// Frontend-origin helper for URLs that another device needs to open.

import { getFrontendUrl } from '@airhead-games/shared/utilities';

const LOCAL_HOSTNAMES = new Set(['localhost', '127.0.0.1', '0.0.0.0', '::1']);

const isLocalHostname = (hostname: string): boolean => {
  return LOCAL_HOSTNAMES.has(hostname.toLowerCase());
};

export const getShareableFrontendUrl = (): string => {
  const fallbackUrl = getFrontendUrl();

  if (!import.meta.env.DEV || typeof window === 'undefined') {
    return fallbackUrl;
  }

  const { protocol, hostname, port } = window.location;
  const lanHostname = import.meta.env.VITE_DEV_SERVER_LAN_HOSTNAME?.trim();

  if (
    !isLocalHostname(hostname) ||
    !lanHostname ||
    isLocalHostname(lanHostname)
  ) {
    return fallbackUrl;
  }

  return `${protocol}//${lanHostname}${port ? `:${port}` : ''}`;
};
